<template>
  <div>
    <a-form-model ref="ruleForm" :model="form" class="info-form" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
      <a-divider orientation="left">
        <span style="font-weight: bold;font-size: 20px;">头像</span>
      </a-divider>
      <div style="margin-left: 80px">
        <Avatar :imageUrl.sync="imageUrl" :imageStyle="{height: '120px', width: '120px'}" @updateAvatar="updateAvatar"/>
      </div>
      <a-divider orientation="left">
        <span style="font-weight: bold;font-size: 20px;">个人信息</span>
      </a-divider>
      <a-row :gutter="[24,8]">
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="name" label="姓名" prop="name">
            <a-input v-if="status==='edit'" v-model="form.name" @blur=" () => { $refs.name.onFieldBlur(); }"/>
            <span v-else>{{ form.name }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="age" label="年龄" prop="age">
            <a-input-number v-if="status==='edit'" v-model="form.age" :min="1" :max="99"/>
            <span v-else>{{ form.age }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="birthday" label="生日" prop="birthday">
            <a-date-picker v-if="status==='edit'" :default-value="moment(form.birthday, 'YYYY-MM-DD')"
                           placeholder="你的生日"/>
            <span v-else>{{ form.birthday }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item label="性别" prop="sex">
            <a-radio-group v-if="status==='edit'" v-model="form.sex">
              <a-radio :value="0">
                女
              </a-radio>
              <a-radio :value="1">
                男
              </a-radio>
            </a-radio-group>
            <span v-else>{{ form.sex === 0 ? '女' : '男' }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item label="血型" prop="blood_type">
            <a-radio-group v-if="status==='edit'" v-model="form.bloodType">
              <a-radio value="A">
                A
              </a-radio>
              <a-radio value="B">
                B
              </a-radio>
              <a-radio value="AB">
                AB
              </a-radio>
              <a-radio value="O">
                O
              </a-radio>
            </a-radio-group>
            <span v-else>{{ form.bloodType }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item label="兴趣爱好" prop="hobby">
            <a-textarea v-if="status==='edit'" v-model="form.hobby"/>
            <span v-else>{{ form.hobby }}</span>
          </a-form-model-item>
        </a-col>
      </a-row>

      <a-divider orientation="left">
        <span style="font-weight: bold;font-size: 20px;">联系方式</span>
      </a-divider>
      <a-row :gutter="24">
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="phone" label="手机" prop="phone">
<!--            <a-input v-if="status==='edit'" v-model="form.phone" placeholder="手机号"/>-->
            <span>{{ form.phone }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="email" label="Email" prop="email">
<!--            <a-input v-if="status==='edit'" v-model="form.email" placeholder="请输入常用邮箱"/>-->
            <span>{{ form.email }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="country" label="国籍" prop="country">
            <a-input v-if="status==='edit'" v-model="form.country" default-value="中国"/>
            <span v-else>{{ form.country }}</span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item label="省市区" prop="province">
            <a-select v-if="status==='edit'" v-model="form.province" placeholder="所在省份" allowClear="true"
                      @change="handleProvinceChange(1)" style="width: 90px">
              <a-select-option v-for="province in provinceData" :key="province.code">
                {{ province.name }}
              </a-select-option>
            </a-select>
            <span v-else v-for="province in provinceData">
              <span v-if="province.code == form.province">{{ province.name }}</span>
            </span>
            <a-select v-if="status==='edit'" v-model="form.city" placeholder="所在城市" @change="handleProvinceChange(2)"
                      style="width: 90px" allowClear="true">
              <a-select-option v-for="city in cityData" :key="city.code">
                {{ city.name }}
              </a-select-option>
            </a-select>
            <span v-else v-for="city in cityData">
              <span v-if="city.code == form.city">{{ city.name }}</span>
            </span>
            <a-select v-if="status==='edit'" v-model="form.area" placeholder="所在区域" style="width: 90px"
                      allowClear="true">
              <a-select-option v-for="area in areaData" :key="area.code">
                {{ area.name }}
              </a-select-option>
            </a-select>
            <span v-else v-for="area in areaData">
              <span v-if="area.code == form.area">{{ area.name }}</span>
            </span>
          </a-form-model-item>
        </a-col>
        <a-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" :xxl="8">
          <a-form-model-item ref="address" label="住址" prop="address">
            <a-input v-if="status==='edit'" v-model="form.address" placeholder="住址"/>
            <span v-else>{{ form.address }}</span>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-divider></a-divider>
      <a-row>
        <a-col :span="24" :style="{ textAlign: 'right' }">
          <a-button v-if="status==='view'" type="primary" @click="changeStatus">
            编辑
          </a-button>
          <a-button v-if="status==='edit'" type="primary" @click="onSubmit">
            提交
          </a-button>
          <a-button v-if="status==='edit'" style="margin-left: 10px;" @click="resetForm">
            取消
          </a-button>
        </a-col>
      </a-row>
    </a-form-model>
  </div>
</template>

<script>
import UserInfoRequest from "@/store/RequestModules/UserInfoRequest";
import UserConfigurationRequest from "@/store/RequestModules/UserConfigurationRequest";
import CommonDataRequest from "@/store/RequestModules/CommonDataRequest";
import moment from "moment";
import SystemUserRequest from "@/store/RequestModules/SystemUserRequest";

export default {
  name: "UserInformation",
  data() {
    return {
      status: 'view',
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      other: '',
      userInfo: this.$store.state.userInfo,
      form: {},
      rules: {
        name: [
          {required: true, message: '君之姓名？', trigger: 'blur'},
          {min: 1, max: 10, message: '星光无限，姓名有长', trigger: 'blur'},
        ],
      },
      imageUrl: '',
      provinceData: [],
      cityData: [],
      areaData: [],
    }
  },
  methods: {
    moment,
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.form.code = this.$store.state.userInfo.code
          UserInfoRequest.saveUserInfo({}, this.form).then(res => {
            if (res.status != '200') {
              this.$message.error('保存失败！');
            }
            // 更新全局参数中的邮箱，后续优化更新所有信息
            if (this.form.email) {
              this.$store.state.userInfo.email = this.form.email
            }
            this.status = 'view'
            this.init()
          })
        } else {
          return false;
        }
      });
    },
    updateAvatar(url) {
      UserConfigurationRequest.updateUserConfiguration({avatar: url}).then(response => {
        if (response.status == '200') {
          SystemUserRequest.info().then(res => {
            const userInfo = res.data.data;
            this.$store.commit("SET_USERINFO", userInfo);
            this.imageUrl = userInfo.avatar
          })
        }
      })
    },
    resetForm() {
      // this.$refs.ruleForm.resetFields();
      this.status = 'view'
    },
    changeStatus() {
      this.status = 'edit';
    },
    handleProvinceChange(type) {
      if (type == 1 && this.form.province != undefined) {
        CommonDataRequest.getProvinceArea(2, this.form.province).then(res => {
          this.cityData = res.data.data
        })
      }
      if (type == 2 && this.form.city != undefined) {
        CommonDataRequest.getProvinceArea(3, this.form.city).then(res => {
          if (res.status != '200') {
            this.$message.error('初始化查询失败！');
          }
          this.areaData = res.data.data
        })
      }
    },
    init() {
      const code = this.$store.state.userInfo.code
      if (!code) {
        this.$message.error('请先登录！', 3);
        //页面跳转
        this.$router.push({name: 'SignIn'});
        return
      }
      UserInfoRequest.getInfoByCode(code).then(res => {
        if (res.status != '200') {
          this.$message.error('初始化查询失败！');
        }
        this.form = res.data.data
        CommonDataRequest.getProvinceArea('1', null).then(res => {
          if (res.status != '200') {
            this.$message.error('初始化查询失败！');
          }
          this.provinceData = res.data.data
        })
        if (this.form.province) {
          CommonDataRequest.getProvinceArea(2, this.form.province).then(res => {
            this.cityData = res.data.data
            if (this.form.city) {
              CommonDataRequest.getProvinceArea(3, this.form.city).then(res => {
                this.areaData = res.data.data
              })
            }
          })
        }
      })
      this.imageUrl = this.$store.state.userInfo.avatar
    }
  },
  created() {
    this.init()
  }
};
</script>

<style>
</style>
